export const localStorageConstants = {
  ADP_USER_REDIRECT: 'adp_users_redirect',
  ADP_ACCOUNT_REDIRECT: 'adp_account_redirect',
  ADP_LOGOUT_REDIRECT: 'adp_logout_redirect',

  ACCESS_TOKEN: 'access_token',
  USER_UNIQUE_TOKEN: 'user_unique_token',
  EXPIRY_DATE: 'expiry_date',
};
